import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { NeuroMessage } from '@ignitesales/neuro-application/src/neuro-guide';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components/MessageContext';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui/index';
import { useUser } from '@ignitesales/neuro-application/src/neuro-guide/hooks';

const SuccessFormModal = ({ className, closeBtn, isOpen, onClose, onSuccessModalClose, selectedProduct, ...rest }) => {
  const messageContext = useNeuroMessages();
  const classes = classnames(className, 'successFormModal contactFormModal');
  const defaultSuccessHeader = messageContext.getMessage('success.default.header');
  const openAccountSuccessHeader = messageContext.getMessage('success.openAccount.header');
  const openAccountSuccessMessage = messageContext.getMessage('success.openAccount.message');
  const openAccountSuccessButton = messageContext.getMessage('success.openAccount.button');
  const scheduleAccountSuccessHeader = messageContext.getMessage('success.scheduleAccount.header');
  const scheduleAccountSuccessMessage = messageContext.getMessage('success.scheduleAccount.message');
  const scheduleAccountSuccessButton = messageContext.getMessage('success.scheduleAccount.button');
  const contactLoanTeamSuccessMessage = messageContext.getMessage('success.contactLoanTeam.message');
  const contactLoanTeamSuccessButton = messageContext.getMessage('success.contactLoanTeam.button');
  const contactUsSuccessMessage = messageContext.getMessage('success.contactUs.message');
  const contactUsSuccessButton = messageContext.getMessage('success.contactUs.button');
  const productActionLogic = selectedProduct.productAction == '4' || selectedProduct.productAction == '5';
  const { uuid } = useUser();
  const onModalClose = () => {
    onSuccessModalClose();
  };

  const isScheduleAction = selectedProduct.productAction == '2' || selectedProduct.productAction == '4';
  const successHeader = (isScheduleAction) ? scheduleAccountSuccessHeader : openAccountSuccessHeader;
  const successButtonText = (isScheduleAction) ? scheduleAccountSuccessButton : openAccountSuccessButton;
  const successButton = (isScheduleAction) ? <a href="#" className='btn btn-primary'><NeuroMessage id={ scheduleAccountSuccessButton } /></a> : <a href="#" className='btn btn-primary'><NeuroMessage id={ openAccountSuccessButton } /></a>;
  const successMessage = () => {
    return (
    <>
      { isScheduleAction  ? 
        <div className="uuid">
          <label>Reference #</label>
          <span>{ uuid }</span>
          <NeuroMessage id={ scheduleAccountSuccessMessage } tagName='p' />
        </div>
      : <NeuroMessage id={ openAccountSuccessMessage } tagName='p' />
      }
      <div onClick={ onSuccessModalClose }>
        { successButton }
      </div>
    </>
    )
  };

  return (
    <Modal
      show={ isOpen }
      className={ classes }
      title={ successHeader }
      onClose={ onClose }
      closeBtn={ closeBtn }
      nodeId="root"
    >
      <div className="shareResults">
        { successMessage() }
      </div>
    </Modal>
  );
};
SuccessFormModal.propTypes = {
  className: PropTypes.string,
  closeBtn: PropTypes.any,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default SuccessFormModal;